// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"549f96b6","408":"37304375","453":"589387cb","910":"0fb69c42"}[chunkId] + ".chunk.js";
};